import { message } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPlayingState } from '../../actions';

import type { Recording, Step } from '../../graphql/types';
import useGiide from '../../hooks/useQuery/useGiide';
import useUser from '../../hooks/useUser';
import { getSignedUrl } from '../utils';

import SoundElement from './SoundElement';
import NewPlayer from './NewPlayer';

interface IRecordsListProps {
  giideId: string;
  recording: Recording;
  disabledDelete?: boolean;
}

const PlayerContainer: React.FC<IRecordsListProps> = ({
  giideId,
  recording,
  disabledDelete = false,
}) => {
  const { data } = useGiide(giideId ?? '');
  const { user } = useUser();
  const [url, setUrl] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  const dispatch = useDispatch();

  const generateFilePath = React.useCallback(() => {
    const giideLibraryId = data?.giideLibraryId;
    const isLibraryStep = (
      data?.steps?.items?.find(step => step?.id === recording.id) as Step
    )?.isInLibrary;
    const tenantID = isLibraryStep
      ? data?.giideLibraryTenantID
      : user?.tenantID;
    const id = isLibraryStep ? giideLibraryId : giideId;
    return `${tenantID}/${id}/${recording.id}.aac`;
  }, [data, giideId, recording.id, user]);

  useEffect(() => {
    setLoading(true);
    getSignedUrl(`public/${recording.filePath ?? generateFilePath()}`)
      .then(data => setUrl(data?.url as string))
      .catch(error => {
        message.error('Could not load the audio file, try refreshing the page');
        console.log(
          'Could not load the audio file, try refreshing the page',
          error
        );
      })
      .finally(() => setLoading(false));
    return () => {
      dispatch(setPlayingState(false));
    };
  }, [
    user,
    setUrl,
    giideId,
    recording.id,
    data,
    recording,
    generateFilePath,
    dispatch,
  ]);

  return (
    <>
      <NewPlayer loading={loading} />
      {url && !loading && (
        <SoundElement url={url} dbLength={recording.length} id={recording.id} />
      )}
    </>
  );
};

export default PlayerContainer;
